import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Target, ShieldCheck, CreditCard } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-72" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-73" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-3 pb-6 px-3 md:pt-4 md:pb-10 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-74">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(201,169,110,0.2) 0%, rgba(201,169,110,0.06) 40%, transparent 70%)'
    }} data-id="element-75" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-76">
        <span className="inline-block py-0.5 px-2.5 rounded-full bg-accent/10 text-accent font-semibold text-xs mb-2 tracking-wide uppercase" data-id="element-77">
          🔥Salud en tu plato
        </span>

        <h1 className="md:text-5xl lg:text-6xl mb-2 font-[900] font-['Open_Sans',_sans-serif] text-white text-[28px]" data-id="element-78">
          Tu sistema clínico nutricional{' '}
          <span className="text-accent" data-id="element-79">completo</span>
        </h1>

        <div className="mb-2 flex justify-center" data-id="element-80">
          <img src="https://cdn.magicpatterns.com/uploads/cJcesagazhqnsKrpEDF8Hb/840d3c08-beed-4f47-b397-42efe0dfb0b4.png" alt="Megapack Pro — Nutrición Clínica" className="w-full max-w-[360px] md:max-w-md drop-shadow-2xl pl-[60px] pr-[60px]" data-id="element-81" />
        </div>

        <p className="md:text-2xl italic text-accent/80 mb-2 max-w-3xl mx-auto text-[15px] font-[800] font-[Avenir,_sans-serif]" data-id="element-82">
          Implementá un sistema ordenado de abordaje clínico para optimizar
          tiempos y mejorar la adherencia del paciente
        </p>

        <p className="text-white/60 max-w-2xl mx-auto mb-3 text-[14px]" data-id="element-83">
          El sistema definitivo para nutricionistas clínicos: evaluación +
          soporte nutricional + protocolos por patología + seguimiento +
          criterio clínico avanzado.
        </p>

        <div className="flex flex-wrap justify-center gap-1.5 mb-3 max-w-3xl mx-auto" data-id="element-84">
          {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-surface border border-accent/10 px-2.5 py-1 rounded-md text-xs text-white/80 font-medium shadow-sm" data-id="element-85">
              <span className="text-accent" data-id="element-86">{badge.icon}</span>
              {badge.text}
            </div>)}
        </div>

        <motion.a href="#comprar" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-accent hover:bg-accent/80 text-black font-bold md:text-lg py-2.5 px-5 md:px-8 rounded-xl shadow-lg shadow-accent/20 transition-colors text-[18px]" data-id="element-87">
          🧠 QUIERO MI MEGAPACK PRO AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-3 mt-3" data-id="element-88">
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-89">
            <Target size={16} className="text-accent" data-id="element-90" />
            Enfoque clínico
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-91">
            <ShieldCheck size={16} className="text-accent" data-id="element-92" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-93">
            <CreditCard size={16} className="text-accent" data-id="element-94" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}